import { render, staticRenderFns } from "./MarkedLetters.vue?vue&type=template&id=62baf2dd"
import script from "./MarkedLetters.vue?vue&type=script&lang=js"
export * from "./MarkedLetters.vue?vue&type=script&lang=js"
import style0 from "./MarkedLetters.vue?vue&type=style&index=0&id=62baf2dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports